// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"_1CDrmlJZciqC44XhbD-2-","AvatarEdit":"_3nhixn3yIttMY-7eymZnSp","AvatarImg":"_3if2CDN5BdGBXmRhPaQX4u"};